import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '../../providers/AuthProvider';
import {
  Box,
  Button,
  Text,
  Image,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
  Heading,
  HStack,
} from '@chakra-ui/react';
import { FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import { BsArrowRight } from 'react-icons/bs';

export default function UpgradePromotionModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const router = useRouter();
  const { currentUser, setLastLoginAt } = useAuth();

  useEffect(() => {
    // Freeプランかつ最終ログインから一定時間経過したら、モーダルopen
    if (currentUser && !currentUser.isSubscribed && hasLastLoginAtExpired()) {
      setLastLoginAt();
      onOpen();
    }
  }, [currentUser]);

  const toBillingPage = () => {
    router.push('/settings/billing');
    onClose();
  };

  // 最終ログインから一定時間経過 or 最終ログインの登録がない場合はtrueを返す
  const hasLastLoginAtExpired = () => {
    const lastLoginAt = localStorage.getItem('last-login-at');
    if (!lastLoginAt) return true;

    const now = new Date();
    const lastLoginDate = new Date(lastLoginAt);
    const diffMs = now - lastLoginDate;
    // 差分を時間単位に変換する
    const diffHours = Math.floor(diffMs / 1000 / 60 / 60);

    // 24時間が経過した場合
    if (diffHours >= 24) {
      return true;
    }

    return false;
  };

  return (
    <>
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size={'2xl'} isCentered>
        <ModalOverlay />
        <ModalContent p={10} paddingTop={5}>
          <ModalHeader textAlign={'center'} p={0}>
            <Flex justifyContent="center">
              <Image src={'/images/common/logo.png'} alt={'Catchy'} w={'300px'} />
            </Flex>
            <Text fontSize={'2xl'} mb={5}>
              現在Freeプランをご利用いただいております
            </Text>
          </ModalHeader>
          <ModalBody p={0}>
            <Box background={'#F7FAFC'} borderRadius={'3px'} mb={5} p={5}>
              <Flex justifyContent="space-between">
                <Box flex={'5'}>
                  <Heading
                    as={'h3'}
                    size={'md'}
                    bg={'#A0AEC0'}
                    color={'white'}
                    py={2}
                    textAlign={'center'}
                    borderRadius={'4px'}
                  >
                    Freeプラン
                  </Heading>
                  <HStack my={3}>
                    <FaTimesCircle color={'red'} />
                    <Text textAlign={'left'}>月10クレジットのみ</Text>
                  </HStack>
                  <HStack my={3}>
                    <FaTimesCircle color={'red'} />
                    <Text textAlign={'left'}>プロジェクト1つまで</Text>
                  </HStack>
                  <HStack my={3}>
                    <FaTimesCircle color={'red'} />
                    <Text textAlign={'left'}>履歴が直近5件まで</Text>
                  </HStack>
                </Box>
                <Box flex={'3'} textAlign={'center'} sx={{ margin: '40px 10px 0' }}>
                  <Text fontSize={'12px'} color={'#3F5FF6'} bgColor={'#ECEFFE'} py={2} borderRadius={'30px'}>
                    アップグレード
                  </Text>
                  <Flex justifyContent="center">
                    <BsArrowRight fontSize={'3rem'} color={'#3F5FF6'} />
                  </Flex>
                </Box>
                <Box flex={'5'}>
                  <Heading
                    as={'h3'}
                    size={'md'}
                    bg={'#3F5FF6'}
                    color={'white'}
                    py={2}
                    textAlign={'center'}
                    borderRadius={'4px'}
                  >
                    Proプラン
                  </Heading>
                  <HStack my={3}>
                    <FaCheckCircle color={'green'} />
                    <Text textAlign={'left'}>クレジット無制限</Text>
                  </HStack>
                  <HStack my={3}>
                    <FaCheckCircle color={'green'} />
                    <Text textAlign={'left'}>最新のWeb情報を含める</Text>
                  </HStack>
                  <HStack my={3}>
                    <FaCheckCircle color={'green'} />
                    <Text textAlign={'left'}>プロジェクト無制限</Text>
                  </HStack>
                  <HStack my={3}>
                    <FaCheckCircle color={'green'} />
                    <Text textAlign={'left'}>履歴無制限</Text>
                  </HStack>
                </Box>
              </Flex>
            </Box>
            <Flex justifyContent={'space-between'}>
              <Button onClick={onClose} color={'#8799B6'} backgroundColor={'#F0F0F0'} size={'lg'} flex={1} mr={4}>
                アップグレードしない
              </Button>
              <Button
                onClick={toBillingPage}
                flex={1}
                bgGradient="linear-gradient(270deg, #3F5FF6 0%, #7000FF 100%)"
                _hover={{ bgGradient: 'linear-gradient(270deg, #3F5FF6 0%, #7000FF 100%)', opacity: 0.9 }}
                color={'white'}
                size={'lg'}
              >
                プランを選択する
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
